// Renders the advisor name as "Mae" with a small superscript "AI" so it reads as
// the AI agent, not a name fragment. Mirrors the inline treatment used in the
// nav (see Nav.tsx mayNavLabel) so branding stays pixel-consistent across surfaces.
export default function MayWordmark() {
  return (
    <>Mae<span style={{ fontSize: 12, fontWeight: 700, position: "relative", top: "-0.35em", marginLeft: "2px", letterSpacing: "0.02em" }}>AI</span></>
  );
}
